module.exports = __webpack_public_path__ + "static/img/top.186516f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/top.webp
// module id = MqTQ
// module chunks = 1